// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__1Bh8A","footer__texts":"footer_footer__texts__1mHzu"};